// Screen id -> component. Each group lives in its own folder (onboarding | day | us | me | desktop).
import type { FunctionComponent } from 'preact';
import type { ScreenId } from '../router';
import { O1Invite, O2Change, O3Stuck, O4Tone, O5CheckIns, O6GotYou, O7Pick, O8FirstHelp, O9DoNow, O10Lit, O11Save } from './onboarding';
import { ChatScreen, TodayScreen, CoworkScreen, StuckScreen, RewardScreen, ShareScreen } from './day';
import { UsScreen, StoryScreen, WeekScreen, CollectionScreen } from './us';
import { MeScreen, BuddyScreen, SwitchScreen, VipScreen, FriendsScreen, CrisisScreen } from './me';
import { Room, MiniWindow } from './desktop';

export const SCREENS: Record<ScreenId, FunctionComponent> = {
  O1: O1Invite, O2: O2Change, O3: O3Stuck, O4: O4Tone, O5: O5CheckIns, O6: O6GotYou, O7: O7Pick,
  O8: O8FirstHelp, O9: O9DoNow, O10: () => <O10Lit />, O11: O11Save,
  C: ChatScreen, T: TodayScreen, W: CoworkScreen, S: StuckScreen, R: RewardScreen, SH: ShareScreen,
  U1: UsScreen, U2: StoryScreen, U3: WeekScreen, U4: CollectionScreen,
  M1: MeScreen, M2: BuddyScreen, M3: SwitchScreen, M4: VipScreen, M5: FriendsScreen, M6: CrisisScreen,
  K1: () => <Room />, K2: MiniWindow,
};
